import React from 'react'
import { useField } from 'formik'
import { Dropdown } from 'primereact/dropdown'
import { useTranslation } from 'react-i18next'

export default function SharedDropdown ({
  label = '',
  name = '',
  className = '',
  labelClassName = '',
  options = [],
  optionLabel = 'label',
  optionValue = 'value',
  placeholder = '',
  ...props
}) {
  const [field, meta] = useField(name)
  const { t } = useTranslation()

  return (
    <div className='flex flex-col gap-1 w-full'>
      {label && (
        <label htmlFor={name} className={labelClassName || 'input-label'}>
          {label}
        </label>
      )}
      <Dropdown
        options={options}
        optionLabel={optionLabel}
        optionValue={optionValue}
        placeholder={placeholder || `${t('select')} ${label}`}
        className={`!w-full input-field ${className} !p-0`}
        pt={{
          input: { className: '!text-[10px] md:!text-[12px] !p-[6px] flex items-center' },
          list: { className: '!py-0 !text-xs' },
          dropdownicon: { className: 'h-[10px] w-[10px] md:h-[12px] md:w-[12px]' }
        }}
        {...field}
        {...props}
      />
      {meta.error && meta.touched && (
        <p className='text-[11px] text-red-500 mt-0.5'>{meta.error}</p>
      )}
    </div>
  )
}
